module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    class: _vm.show && 'is-active'
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "title is-1 text-center"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage),
      expression: "errorMessage"
    }],
    staticClass: "has-text-danger text-center"
  }, [_vm._v(_vm._s(_vm.errorMessage))]), _vm._v(" "), _c('p', {
    staticClass: "content text-center pl-4 pr-4"
  }, [_vm._v("\n        " + _vm._s(_vm.message) + "\n      ")]), _vm._v(" "), _c('section', {
    staticClass: "button-container text-center"
  }, [_c('button', {
    staticClass: "button is-danger",
    class: _vm.loading && 'is-loading',
    attrs: {
      "type": "button",
      "tabIndex": "2"
    },
    on: {
      "click": function($event) {
        _vm.confirm()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.completeButtonText || 'Delete') + "\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "tabIndex": "1",
      "id": "confirmCancel",
      "value": "Cancel"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-7cf04b24"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Confirm.vue
// module id = 1072
// module chunks = 0